/**
 * Quantas colunas da grade de filtros cada campo ocupa.
 *
 * Antes cada tela inventava a sua largura (minWidth 140/150/170/200 cruzado
 * com maxWidth 160/180/210/260), entao campos do mesmo tipo ficavam com
 * tamanhos diferentes e nada alinhava entre as abas. Quem decide a largura
 * agora e a grade do Filter.Container: colunas iguais, de no minimo 175px,
 * que se ajustam ao tamanho da tela. As lojas usam monitores bem diferentes,
 * entao em tela estreita cabem menos colunas em vez de os campos encolherem
 * ate ficarem ilegiveis.
 *
 * Um campo so escolhe entre ocupar uma coluna (o normal) ou duas, quando
 * precisa de espaco para texto livre.
 */
const colunas = (quantas) => ({ gridColumn: `span ${quantas}` });

export const CAMPO = {
  pequeno: colunas(1),
  medio: colunas(1),
  grande: colunas(1),
  busca: colunas(2),
};
